
<ng-container *ngIf="isWorkflowOnSubscriber || !isMandatoryDocumentation || userSendingClinicalDocs">
<fieldset *ngIf="isVersion2()" [disabled]="readonlyAdditionalDoc">
  <div class="row d-flex align-items-center" >
    <div class="col-sm-6">
      <h2 class="text-primary mb-0">
        <span *ngIf="!readonlyAdditionalDoc">{{cardConfiguration.title}}</span>
        <span *ngIf="readonlyAdditionalDoc">{{'CardDocumentation.DocumentsTable.Title' | translate}}</span>
      </h2>
    </div>

    <div class="col-sm-6 text-end" *ngIf="showAddDocButton" >
      <button (click)="expandNewEntry=!expandNewEntry"
              [ngClass]="!expandNewEntry ? '' : 'disabled'"
              type="button"
              aria-label="Nova entrada"
              class="btn btn-link disable-on-fieldset">
        <span class="icon-add"></span> <span>{{'CardDocumentation.DocumentsTable.AddItem' | translate}}</span>
      </button>
    </div>
  </div>

  <!--New table entry inputs-->
  <div *ngIf="expandNewEntry" class="shadow ml-5 mr-5 p-4 mb-4 mt-5">
    <button type="button" class="close" aria-label="Fechar" (click)="expandNewEntry=!expandNewEntry">
      <span aria-hidden="true" class="icon-close text-primary"></span>
    </button>
    <h3 class="text-primary">{{'CardDocumentation.DocumentsTable.AddItem' | translate}}</h3>
    <documentation-table-edit
                              [isWorkflowMandatory]="isWorkflowMandatory" [itemList]="cardData.documentsList" (listChanged)="onDocumentationChanged($event)" [workflowInstanceId]="workflowInstanceId"
                              [isMandatoryDocumentation]="isMandatoryDocumentation" [isWorkflowOnSubscriber]="isWorkflowOnSubscriber" [isIncapacity]="isWorkflowIncapacity"></documentation-table-edit>
  </div>
  <table class="table table-striped">
    <thead>
      <tr>
        <th></th>
        <th scope="col">{{'CardDocumentation.DocumentsTable.Designation' | translate}} <span tabindex="0" class="ml-1 text-primary icon-help" aria-label="Tooltip com informação" tooltip="{{'Tooltips.Documents.Designation' | translate}}"></span></th>
        <th scope="col">{{'CardDocumentation.DocumentsTable.Name' | translate}}</th>
        <th scope="col">Ficheiro</th>
        <th scope="col"></th>
      </tr>
    </thead>
    <tbody>
      <ng-container *ngFor="let tableItem of cardData.documentsList; let i = index">
        <tr  *ngIf="showDocRow(tableItem)" [ngClass]="expandedRowIndex == i ? 'text-primary table-active-top-border' : 'enabled'" (click)="expandRow(i)">
          <td style="color:red !important;font-size:2rem;padding-top:6px;text-align:center;">{{markAsMandatory(tableItem)? '*' : ''}}</td>
          <td *ngIf="tableItem.designationTypeCode === 'ECL000'">{{tableItem.designationTypeCode |  commonData : designationTypes : 'code' : 'desc'}}</td>
          <td *ngIf="tableItem.designationTypeCode !== 'ECL000'">{{tableItem.description |  commonData : designationTypes : 'code' : 'desc'}}</td>
          <td>{{tableItem.name }}</td>
          <td>{{tableItem.fileName}}</td>
          <td class="buttons-edit" [ngClass]="expandedRowIndex == enabled ? 'active' : 'inactive'">
            <button type="button" class="btn-icon" aria-label="Editar" [attr.aria-expanded]="expandedRowIndex == i" aria-controls="collapseBasic">
              <span class="p-1" *ngIf="!readonlyAdditionalDoc" [ngClass]="expandedRowIndex == i ? 'text-primary  icon-close' : tableItem.fileID ? 'text-primary icon-edit' : 'text-primary icon-more' "></span>
              <span class="p-1" *ngIf="readonlyAdditionalDoc" [ngClass]="expandedRowIndex == i ? 'text-primary  icon-close' : tableItem.fileID ? 'text-primary icon-more' : 'text-primary icon-more' "></span>
            </button>
          </td>
        </tr>
        <tr *ngIf="showDocRow(tableItem) && (expandedRowIndex == i)" [collapse]="expandedRowIndex != i" [isAnimated]="false">
          <td class="p-0" colspan="5" id="collapseBasic">
            <div class="ml-5 mr-5 p-4">
              <documentation-table-edit [itemList]="cardData.documentsList" [editIndex]="i" (listChanged)="onDocumentationChanged($event)"
                                        [isMandatoryDocumentation]="userSendingClinicalDocs"  [isWorkflowOnSubscriber]="isWorkflowOnSubscriber"
                                        [isIncapacity]="isWorkflowIncapacity" [isReadonly]="readonlyAdditionalDoc" [workflowInstanceId]="workflowInstanceId"
                                        [isWorkflowMandatory]="isWorkflowMandatory">

              </documentation-table-edit>
            </div>
          </td>
        </tr>
      </ng-container>
    </tbody>
  </table>
</fieldset>

<fieldset *ngIf="!isVersion2()" [disabled]="readonlyAdditionalDoc">
  <div class="row d-flex align-items-center">
    <div class="col-sm-6">
      <h2 class="text-primary mb-0">
        <span *ngIf="!readonlyAdditionalDoc">{{cardConfiguration.title}}</span>
        <span *ngIf="readonlyAdditionalDoc">{{'CardDocumentation.DocumentsTable.Title' | translate}}</span>
      </h2>
    </div>

    <div class="col-sm-6 text-end" *ngIf="showAddDocButton">
      <button (click)="expandNewEntry=!expandNewEntry"
              [ngClass]="!expandNewEntry ? '' : 'disabled'"
              type="button"
              aria-label="Nova entrada"
              class="btn btn-link disable-on-fieldset">
        <span class="icon-add"></span> <span>{{'CardDocumentation.DocumentsTable.AddItem' | translate}}</span>
      </button>
    </div>
  </div>

  <!--New table entry inputs-->
  <div *ngIf="expandNewEntry" class="shadow ml-5 mr-5 p-4 mb-4 mt-5">
    <button type="button" class="close" aria-label="Fechar" (click)="expandNewEntry=!expandNewEntry">
      <span aria-hidden="true" class="icon-close text-primary"></span>
    </button>
    <h3 class="text-primary">{{'CardDocumentation.DocumentsTable.AddItem' | translate}}</h3>
    <documentation-table-edit [isWorkflowMandatory]="isWorkflowMandatory" [itemList]="cardData.documentsList" (listChanged)="onDocumentationChanged($event)"
                              [isMandatoryDocumentation]="isMandatoryDocumentation" [isWorkflowOnSubscriber]="isWorkflowOnSubscriber" [isIncapacity]="isWorkflowIncapacity"></documentation-table-edit>
  </div>
  <table class="table table-striped">
    <thead>
      <tr>
        <th></th>
        <th scope="col">{{'CardDocumentation.DocumentsTable.Designation' | translate}} <span tabindex="0" class="ml-1 text-primary icon-help" aria-label="Tooltip com informação" tooltip="{{'Tooltips.Documents.Designation' | translate}}"></span></th>
        <th scope="col">{{'CardDocumentation.DocumentsTable.Name' | translate}}</th>
        <th scope="col">Ficheiro</th>
        <th scope="col"></th>
      </tr>
    </thead>
    <tbody>
      <ng-container *ngFor="let tableItem of cardData.documentsList; let i = index">
        <tr *ngIf="showDocRow(tableItem)" [ngClass]="expandedRowIndex == i ? 'text-primary table-active-top-border' : 'enabled'" (click)="expandRow(i)">
          <td style="color:red;font-size:2rem;padding-top:6px;text-align:center;">{{markAsMandatory(tableItem)? '*' : ''}}</td>
          <td>{{tableItem.designationTypeCode |  commonData : designationTypes : 'code' : 'desc'}}</td>
          <td>{{tableItem.name }}</td>
          <td>{{tableItem.fileName}}</td>
          <td class="buttons-edit" [ngClass]="expandedRowIndex == enabled ? 'active' : 'inactive'">
            <button type="button" class="btn-icon" aria-label="Editar" [attr.aria-expanded]="expandedRowIndex == i" aria-controls="collapseBasic">
              <span class="p-1" *ngIf="!readonlyAdditionalDoc" [ngClass]="expandedRowIndex == i ? 'text-primary  icon-close' : tableItem.fileID ? 'text-primary icon-edit' : 'text-primary icon-more' "></span>
              <span class="p-1" *ngIf="readonlyAdditionalDoc" [ngClass]="expandedRowIndex == i ? 'text-primary  icon-close' : tableItem.fileID ? 'text-primary icon-more' : 'text-primary icon-more' "></span>
            </button>
          </td>
        </tr>
        <tr *ngIf="showDocRow(tableItem) && (expandedRowIndex == i)" [collapse]="expandedRowIndex != i" [isAnimated]="false">
          <td class="p-0" colspan="5" id="collapseBasic">
            <div class="ml-5 mr-5 p-4">
              <documentation-table-edit [itemList]="cardData.documentsList" [editIndex]="i" (listChanged)="onDocumentationChanged($event)"
                                        [isMandatoryDocumentation]="userSendingClinicalDocs" [isWorkflowOnSubscriber]="isWorkflowOnSubscriber"
                                        [isIncapacity]="isWorkflowIncapacity" [isReadonly]="readonlyAdditionalDoc"
                                        [isWorkflowMandatory]="isWorkflowMandatory"></documentation-table-edit>
            </div>
          </td>
        </tr>
      </ng-container>
    </tbody>
  </table>
</fieldset>
  <br /><br />
</ng-container>
<!--<pre>{{cardData | json}}</pre>-->
